type Props = {
  items: string[]
}

export function BulletList({ items }: Props) {
  return (
    <ul className="flex list-disc flex-col gap-2 pl-5">
      {items.map((item) => (
        <li key={item} className="text-body">
          {item}
        </li>
      ))}
    </ul>
  )
}
